const BASE_STUDENTS_FOR_REMARKS = [
  {
    id: 1,
    studentId: 'STU-001',
    fullName: 'Aarav Mehta',
    rollNo: '101',
    idCardNo: 'CARD-8901',
    instituteName: 'Tez Educational Trust',
    branchName: 'Dadar',
    courseName: 'CA Foundation',
    batchNames: 'Batch-A (Morning)',
    schoolName: 'Main Campus',
    academicYear: '2026-2027',
    subjectNames: 'Principles and Practice of Accounting',
  },
  {
    id: 2,
    studentId: 'STU-002',
    fullName: 'Ananya Sharma',
    rollNo: '102',
    idCardNo: 'CARD-8902',
    instituteName: 'Tez Educational Trust',
    branchName: 'Dadar',
    courseName: 'CA Foundation',
    batchNames: 'Batch-A (Morning)',
    schoolName: 'Main Campus',
    academicYear: '2026-2027',
    subjectNames: 'Principles and Practice of Accounting',
  },
  {
    id: 3,
    studentId: 'STU-003',
    fullName: 'Rohan Deshmukh',
    rollNo: '204',
    idCardNo: 'CARD-9011',
    instituteName: 'Tolani College Of Commerce',
    branchName: 'Thane',
    courseName: 'CS Executive',
    batchNames: 'Batch-CS-01',
    schoolName: 'East Annex',
    academicYear: '2026-2027',
    subjectNames: 'Company Law & Practice',
  },
  {
    id: 4,
    studentId: 'STU-004',
    fullName: 'Pooja Iyer',
    rollNo: '205',
    idCardNo: 'CARD-9014',
    instituteName: 'Tolani College Of Commerce',
    branchName: 'Thane',
    courseName: 'CS Executive',
    batchNames: 'Batch-CS-01',
    schoolName: 'East Annex',
    academicYear: '2026-2027',
    subjectNames: 'Company Law & Practice',
  },
  {
    id: 5,
    studentId: 'STU-005',
    fullName: 'Kabir Patel',
    rollNo: '301',
    idCardNo: 'CARD-7731',
    instituteName: 'Tez Educational School',
    branchName: 'Andheri',
    courseName: 'JEE Advanced',
    batchNames: 'Super-30 (Intensive)',
    schoolName: 'North Campus',
    academicYear: '2026-2027',
    subjectNames: 'Physics, Mathematics',
  },
  {
    id: 6,
    studentId: 'STU-006',
    fullName: 'Ishaan Kulkarni',
    rollNo: '302',
    idCardNo: 'CARD-7732',
    instituteName: 'Tez Educational School',
    branchName: 'Andheri',
    courseName: 'JEE Advanced',
    batchNames: 'Super-30 (Intensive)',
    schoolName: 'North Campus',
    academicYear: '2026-2027',
    subjectNames: 'Physics, Mathematics',
  },
  {
    id: 7,
    studentId: 'STU-007',
    fullName: 'Diya Singhania',
    rollNo: '401',
    idCardNo: 'CARD-6102',
    instituteName: 'Tez Educational Trust',
    branchName: 'Borivali',
    courseName: 'NEET UG',
    batchNames: 'Med-Achievers',
    schoolName: 'Main Campus',
    academicYear: '2026-2027',
    subjectNames: 'Biology (Botany), Chemistry',
  },
  {
    id: 8,
    studentId: 'STU-008',
    fullName: 'Siddharth Joshi',
    rollNo: '402',
    idCardNo: 'CARD-6103',
    instituteName: 'Tez Educational Trust',
    branchName: 'Borivali',
    courseName: 'NEET UG',
    batchNames: 'Med-Achievers',
    schoolName: 'Main Campus',
    academicYear: '2026-2027',
    subjectNames: 'Biology (Botany), Chemistry',
  },
]

const SEED_REMARKS = [
  {
    id: 1,
    studentId: 'STU-001',
    fullName: 'Aarav Mehta',
    rollNo: '101',
    idCardNo: 'CARD-8901',
    instituteName: 'Tez Educational Trust',
    branchName: 'Dadar',
    courseName: 'CA Foundation',
    batchNames: 'Batch-A (Morning)',
    academicYear: '2026-2027',
    remarkDate: '2026-08-18',
    remarkName: 'Late Coming',
    particulars: 'Arrived 25 minutes after the accounting lecture commenced without prior intimation.',
    remarkedBy: 'Prof. S. K. Mehta',
    createdAt: '2026-08-18T09:30:00Z',
  },
  {
    id: 2,
    studentId: 'STU-002',
    fullName: 'Ananya Sharma',
    rollNo: '102',
    idCardNo: 'CARD-8902',
    instituteName: 'Tez Educational Trust',
    branchName: 'Dadar',
    courseName: 'CA Foundation',
    batchNames: 'Batch-A (Morning)',
    academicYear: '2026-2027',
    remarkDate: '2026-08-17',
    remarkName: 'Appreciation',
    particulars: 'Scored highest marks (98/100) in the weekly corporate accounting assessment.',
    remarkedBy: 'Prof. S. K. Mehta',
    createdAt: '2026-08-17T14:15:00Z',
  },
  {
    id: 3,
    studentId: 'STU-005',
    fullName: 'Kabir Patel',
    rollNo: '301',
    idCardNo: 'CARD-7731',
    instituteName: 'Tez Educational School',
    branchName: 'Andheri',
    courseName: 'JEE Advanced',
    batchNames: 'Super-30 (Intensive)',
    academicYear: '2026-2027',
    remarkDate: '2026-08-16',
    remarkName: 'Homework Incomplete',
    particulars: 'Physics wave optics assignment 4 problems not attempted.',
    remarkedBy: 'Dr. V. Raman',
    createdAt: '2026-08-16T11:00:00Z',
  },
  {
    id: 4,
    studentId: 'STU-007',
    fullName: 'Diya Singhania',
    rollNo: '401',
    idCardNo: 'CARD-6102',
    instituteName: 'Tez Educational Trust',
    branchName: 'Borivali',
    courseName: 'NEET UG',
    batchNames: 'Med-Achievers',
    academicYear: '2026-2027',
    remarkDate: '2026-08-15',
    remarkName: 'Parent Meeting Required',
    particulars: 'Frequent absenteeism during Friday laboratory practicals.',
    remarkedBy: 'Admin Office',
    createdAt: '2026-08-15T16:00:00Z',
  },
]

function getStoredRemarks() {
  try {
    const raw = localStorage.getItem('remarks_records')
    if (!raw) {
      localStorage.setItem('remarks_records', JSON.stringify(SEED_REMARKS))
      return SEED_REMARKS
    }
    return JSON.parse(raw)
  } catch {
    return SEED_REMARKS
  }
}

function saveStoredRemarks(list) {
  try {
    localStorage.setItem('remarks_records', JSON.stringify(list))
    window.dispatchEvent(new Event('remarks-records-updated'))
  } catch (err) {
    console.error('Failed to save remarks to localStorage', err)
  }
}

export async function fetchRemarksList(filters = {}, sortBy = 'remarkDate', sortOrder = 'desc') {
  await new Promise((resolve) => setTimeout(resolve, 80))

  let list = getStoredRemarks()

  // Filter: Company
  if (filters.company && filters.company !== 'All') {
    list = list.filter((r) => r.instituteName === filters.company)
  }
  // Filter: Branch
  if (filters.branch && filters.branch !== 'All') {
    list = list.filter((r) => r.branchName === filters.branch)
  }
  // Filter: Course
  if (filters.course && filters.course !== 'All') {
    list = list.filter((r) => r.courseName === filters.course)
  }
  // Filter: Batch
  if (filters.batch && filters.batch !== 'All') {
    list = list.filter((r) => r.batchNames === filters.batch)
  }
  // Filter: Academic Year
  if (filters.academicYear && filters.academicYear !== 'All') {
    list = list.filter((r) => r.academicYear === filters.academicYear)
  }
  // Filter: Remark Type / Category
  if (filters.remarkType && filters.remarkType !== 'All') {
    list = list.filter((r) => r.remarkName === filters.remarkType)
  }

  // Filter: Date Range (From - Till)
  if (filters.fromDate) {
    list = list.filter((r) => r.remarkDate >= filters.fromDate)
  }
  if (filters.tillDate) {
    list = list.filter((r) => r.remarkDate <= filters.tillDate)
  }

  // Search Filter
  if (filters.searchText) {
    const q = filters.searchText.toLowerCase().trim()
    const field = filters.searchField || 'All'
    list = list.filter((r) => {
      if (field === 'Student') return r.fullName.toLowerCase().includes(q)
      if (field === 'RollNo') return r.rollNo.toLowerCase().includes(q)
      if (field === 'IdCardNo') return (r.idCardNo || '').toLowerCase().includes(q)
      if (field === 'Remark') return r.remarkName.toLowerCase().includes(q)
      if (field === 'Course') return r.courseName.toLowerCase().includes(q)
      if (field === 'Batch') return r.batchNames.toLowerCase().includes(q)
      if (field === 'Branch') return r.branchName.toLowerCase().includes(q)
      if (field === 'Company') return r.instituteName.toLowerCase().includes(q)
      return (
        r.fullName.toLowerCase().includes(q) ||
        r.rollNo.toLowerCase().includes(q) ||
        (r.idCardNo || '').toLowerCase().includes(q) ||
        r.remarkName.toLowerCase().includes(q) ||
        (r.particulars || '').toLowerCase().includes(q) ||
        r.courseName.toLowerCase().includes(q) ||
        r.batchNames.toLowerCase().includes(q) ||
        r.branchName.toLowerCase().includes(q) ||
        r.instituteName.toLowerCase().includes(q)
      )
    })
  }

  // Sorting
  list.sort((a, b) => {
    let valA = a[sortBy] ?? ''
    let valB = b[sortBy] ?? ''
    if (sortBy === 'rollNo') {
      const numA = parseInt(valA, 10) || 0
      const numB = parseInt(valB, 10) || 0
      return sortOrder === 'asc' ? numA - numB : numB - numA
    }
    if (typeof valA === 'string') {
      return sortOrder === 'asc' ? valA.localeCompare(valB) : valB.localeCompare(valA)
    }
    return sortOrder === 'asc' ? valA - valB : valB - valA
  })

  return {
    records: list,
    totalRecords: list.length,
  }
}

export async function fetchStudentsForRemarks(filters = {}) {
  await new Promise((resolve) => setTimeout(resolve, 50))

  let list = [...BASE_STUDENTS_FOR_REMARKS]

  if (filters.company && filters.company !== 'All') {
    list = list.filter((s) => s.instituteName === filters.company)
  }
  if (filters.branch && filters.branch !== 'All') {
    list = list.filter((s) => s.branchName === filters.branch)
  }
  if (filters.course && filters.course !== 'All') {
    list = list.filter((s) => s.courseName === filters.course)
  }
  if (filters.batch && filters.batch !== 'All') {
    list = list.filter((s) => s.batchNames === filters.batch)
  }
  if (filters.academicYear && filters.academicYear !== 'All') {
    list = list.filter((s) => s.academicYear === filters.academicYear)
  }
  if (filters.subject && filters.subject !== 'All') {
    list = list.filter((s) => s.subjectNames.includes(filters.subject))
  }
  if (filters.searchText) {
    const q = filters.searchText.toLowerCase().trim()
    const field = filters.searchField || 'All'
    list = list.filter((s) => {
      if (field === 'Student') return s.fullName.toLowerCase().includes(q)
      if (field === 'RollNo') return s.rollNo.toLowerCase().includes(q)
      if (field === 'IdCardNo') return (s.idCardNo || '').toLowerCase().includes(q)
      if (field === 'Course') return s.courseName.toLowerCase().includes(q)
      if (field === 'Batch') return s.batchNames.toLowerCase().includes(q)
      return (
        s.fullName.toLowerCase().includes(q) ||
        s.rollNo.toLowerCase().includes(q) ||
        (s.idCardNo || '').toLowerCase().includes(q) ||
        s.courseName.toLowerCase().includes(q) ||
        s.batchNames.toLowerCase().includes(q) ||
        s.branchName.toLowerCase().includes(q) ||
        s.instituteName.toLowerCase().includes(q)
      )
    })
  }

  return list
}

export async function getRemarkById(id) {
  await new Promise((resolve) => setTimeout(resolve, 50))
  const list = getStoredRemarks()
  const found = list.find((r) => r.id === parseInt(id, 10))
  if (!found) throw new Error(`Remark not found with ID ${id}`)
  return found
}

export async function createBulkRemarks({
  studentIds = [],
  remarkDate,
  remarkName,
  remarkedBy,
  particulars,
}) {
  await new Promise((resolve) => setTimeout(resolve, 150))
  const list = getStoredRemarks()

  const newRecords = []
  studentIds.forEach((sId) => {
    const student = BASE_STUDENTS_FOR_REMARKS.find((s) => s.id === sId)
    if (student) {
      const record = {
        id: Date.now() + Math.floor(Math.random() * 1000),
        studentId: student.studentId,
        fullName: student.fullName,
        rollNo: student.rollNo,
        idCardNo: student.idCardNo,
        instituteName: student.instituteName,
        branchName: student.branchName,
        courseName: student.courseName,
        batchNames: student.batchNames,
        academicYear: student.academicYear,
        remarkDate: remarkDate || new Date().toISOString().split('T')[0],
        remarkName: remarkName || 'General Observation',
        particulars: particulars || '',
        remarkedBy: remarkedBy || 'Faculty / Staff',
        createdAt: new Date().toISOString(),
      }
      newRecords.push(record)
    }
  })

  const updatedList = [...newRecords, ...list]
  saveStoredRemarks(updatedList)
  return newRecords
}

export async function updateRemark(id, payload) {
  await new Promise((resolve) => setTimeout(resolve, 120))
  const list = getStoredRemarks()
  const targetId = parseInt(id, 10)

  const updatedList = list.map((item) => {
    if (item.id === targetId) {
      return {
        ...item,
        ...payload,
        updatedAt: new Date().toISOString(),
      }
    }
    return item
  })

  saveStoredRemarks(updatedList)
  return updatedList.find((r) => r.id === targetId)
}

export async function deleteRemark(id) {
  await new Promise((resolve) => setTimeout(resolve, 100))
  const list = getStoredRemarks()
  const targetId = parseInt(id, 10)
  const filtered = list.filter((r) => r.id !== targetId)
  saveStoredRemarks(filtered)
  return { success: true }
}
